import React, { useRef } from "react";
import classNames from "classnames";
import styles from "./FocusPointSelector.scss";
import { DisplayFrame } from "../../form";

export const FocusPointSelector = ({ focusPoint, onChange, enabled, children, lang }) => {
    const baseRef = useRef(null);
    const handleChange = (event) => {
        if (!enabled) {
            return;
        } else {
            const baseProps = baseRef.current.getBoundingClientRect();
            console.log(event, baseProps);
            const pointX = Math.round(((event.clientX - baseProps.left) / baseProps.width) * 10000) / 100;
            const pointY = Math.round(((event.clientY - baseProps.top) / baseProps.height) * 10000) / 100;
            onChange({
                x: pointX,
                y: pointY
            });
        }
    };

    return (
        <DisplayFrame active={enabled}>
            <div
                ref={baseRef}
                className={classNames(styles.base, {
                    [styles.enabled]: enabled
                })}
                onClick={handleChange}
            >
                {enabled && <div className={styles.message}>{lang.message}</div>}
                {focusPoint?.x && focusPoint?.y ? (
                    <div
                        className={styles.point}
                        style={{
                            left: `${focusPoint.x}%`,
                            top: `${focusPoint.y}%`
                        }}
                    />
                ) : null}
                {children}
            </div>
        </DisplayFrame>
    );
};

FocusPointSelector.defaultProps = {
    enabled: true,
    focusPoint: null,
    lang: {
        message: "Klikk for å velge fokuspunkt"
    }
};
